// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import ShareBlock from '../ShareBlock/ShareBlock';
// helpers
import makeSharingUrl from '../../utils/makeSharingUrl';
import { ROUTES } from '../../constants';

const ShareButton = ({
  id,
  slug,
  locale,
  isProject,
  translate,
  isNative,
  shareLinkClassName,
  isToolbar,
  iconLinkShareClass = 'icon icon-contacts-share-fill',
  onShare,
  additionalToolbarBtnClassName,
  formatShareData,
  shareBlockClassName
}) => {
  const target = isProject ? ROUTES.PROJECT_DETAILS : ROUTES.PROPERTY_DETAILS;
  const sharingUrl = makeSharingUrl(`/${target}/${slug || id}`, locale);
  const protocol = (sharingUrl.includes('://')) ? '' : 'https://';
  const fullUrl = `${protocol}${sharingUrl}`;
  const isNativeSharingSupported = typeof navigator !== 'undefined' && !!navigator && !!navigator.share;

  const handleClickNativeLink = () => {
    if (!isNative) {
      return;
    }

    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'share',
        url: fullUrl
      }));
    } else {
      console.warn('ReactNativeWebView is not available');
    }
  };

  if (isNative) {
    return (
      <span
        onClick={handleClickNativeLink}
        className={shareLinkClassName}
      >
        <span className={iconLinkShareClass} />
        {!isToolbar && <span>{translate('propertyDetails', 'shareTitle')}</span>}
      </span>
    );
  }

  const handleClickShare = () => {
    if (navigator.share) {
      navigator.share({
        url: fullUrl,
        title: formatShareData.sharingTitle || undefined
      });
      return;
    }
    onShare();
  };

  if (isToolbar) {
    return (
      <p
        onClick={handleClickShare}
        className={additionalToolbarBtnClassName}
      >
        <i className="icon icon-export" />
      </p>
    );
  }

  if (isNativeSharingSupported) {
    return (
      <span
        onClick={handleClickShare}
        className={shareLinkClassName}
      >
        <span className={iconLinkShareClass} />
        <span>{translate('propertyDetails', 'shareTitle')}</span>
      </span>
    );
  }

  return (
    <ShareBlock
      locale={locale}
      translate={translate}
      sharingData={formatShareData}
      copyLinkTitle={`${translate('copyLink')}`}
      emailTitle={`${translate('propertyDetails', 'contacts', 'email')}`}
      className={shareBlockClassName}
      sizeIcon={24}
      iconFill
    />
  );
};

ShareButton.propTypes = {
  id: PropTypes.string,
  locale: PropTypes.string,
  isNative: PropTypes.bool,
  translate: PropTypes.func,
  isProject: PropTypes.string,
  isToolbar: PropTypes.bool,
  formatShareData: PropTypes.func,
  wrapperTag: PropTypes.string,
  onShare: PropTypes.func,
  additionalToolbarBtnClassName: PropTypes.object,
  shareLinkClassName: PropTypes.string,
  iconLinkShareClass: PropTypes.string,
  shareBlockClassName: PropTypes.string,
  slug: PropTypes.string
};

export default ShareButton;
